// extracted by mini-css-extract-plugin
export default {"button":"Button__button--uwjVm"};